module.exports = __webpack_public_path__ + "img/device.45c4fa1e.svg";